import { render } from "./RentalVehicle.vue?vue&type=template&id=1ff71e54"
import script from "./RentalVehicle.vue?vue&type=script&lang=js"
export * from "./RentalVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__